import { cva } from "../../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../../lib/utils.js";
const selectBasicClassNames = "group flex min-w-0 border transition-[background-color,border-color,color,box-shadow]", selectTriggerVariants = cva(
  cn`
    ${selectBasicClassNames}
    text-(--gray-text-2) outline-none rounded-md placeholder:text-(--gray-primary-1-alpha)
  `,
  {
    variants: {
      size: {
        sm: "min-h-6 px-1",
        default: "min-h-9 px-2 py-1",
        lg: "min-h-10 px-2 py-1"
      },
      focus: { default: "", focus: "" },
      disabled: {
        default: "",
        disabled: "bg-(--gray-bg-2-alpha)"
      },
      variant: {
        default: "bg-(--white) border-(--gray-tag-3-alpha) aria-invalid:border-(--red-6-alpha)",
        filled: "border-transparent bg-(--tag-1-alpha) aria-invalid:bg-(--red-3-alpha)",
        ghost: "border-transparent"
      },
      multiple: {
        default: "",
        multiple: ""
      }
    },
    compoundVariants: [
      { size: "sm", multiple: "default", class: "h-6" },
      { size: "default", multiple: "default", class: "h-9" },
      { size: "lg", multiple: "default", class: "h-10" },
      { size: "sm", multiple: "multiple", class: "min-h-6" },
      { size: "default", multiple: "multiple", class: "min-h-9" },
      { size: "lg", multiple: "multiple", class: "min-h-10" },
      // 默认样式 + 默认状态
      {
        disabled: "default",
        variant: "default",
        class: cn`
                  focus:border-(--border-3-alpha)         focus:ring-(--border-1-alpha)         focus:border-ring         focus:ring-[1px]
           data-[focus]:border-(--border-3-alpha)  data-[focus]:ring-(--border-1-alpha)  data-[focus]:border-ring  data-[focus]:ring-[1px] 
                  aria-invalid:focus:border-(--red-6-alpha)         aria-invalid:focus:ring-(--red-3-alpha)
           data-[focus]:aria-invalid:border-(--red-6-alpha)  data-[focus]:aria-invalid:ring-(--red-3-alpha)
        `
      },
      {
        disabled: "default",
        variant: "filled",
        class: cn`
                        hover:bg-(--tag-2-alpha)              focus:bg-(--tag-3-alpha)              data-[focus]:bg-(--tag-3-alpha)
           aria-invalid:hover:bg-(--red-4-alpha) aria-invalid:focus:bg-(--red-5-alpha) aria-invalid:data-[focus]:bg-(--red-5-alpha)
        `
      },
      // ghost样式 + 默认状态
      {
        disabled: "default",
        variant: "ghost",
        class: cn`
                       hover:bg-(--tag-1-alpha)              focus:bg-(--tag-2-alpha)              data-[focus]:bg-(--tag-2-alpha)
          aria-invalid:hover:bg-(--red-3-alpha) aria-invalid:focus:bg-(--red-4-alpha) aria-invalid:data-[focus]:bg-(--red-4-alpha)
        `
      }
    ],
    defaultVariants: {
      size: "default",
      focus: "default",
      disabled: "default",
      variant: "default",
      multiple: "default"
    }
  }
), selectTriggerGroupVariants = cva(
  "flex items-center w-full",
  {
    variants: {
      size: {
        sm: "gap-1",
        default: "gap-2",
        lg: "gap-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), selectTriggerSuffixVariants = cva(
  "flex shrink-0",
  {
    variants: {
      size: {
        sm: "gap-1",
        default: "gap-2",
        lg: "gap-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), selectTextVariants = cva(
  "group-aria-invalid:text-(--red-12)",
  {
    variants: {
      size: {
        sm: "text-sm",
        default: "text-base",
        lg: "text-lg"
      },
      color: {
        default: cn`
          text-(--gray-text-2) disabled:text-(--gray-border-3-alpha)
          data-[placeholder]:text-(--gray-primary-1-alpha) data-[placeholder]:whitespace-nowrap
        `,
        disabled: "text-(--gray-border-3-alpha)"
      }
    },
    defaultVariants: {
      size: "default",
      color: "default"
    }
  }
), selectValueVariants = cva(
  "block size-full content-center",
  {
    variants: {
      size: {
        sm: "gap-0.5",
        default: "gap-1",
        lg: "gap-1"
      },
      multiple: {
        default: "",
        multiple: "flex flex-wrap"
      }
    },
    defaultVariants: {
      size: "default",
      multiple: "default"
    }
  }
), selectValueTagVariants = cva("group-aria-invalid:bg-(--red-3-alpha) group-aria-invalid:text-(--red-11)"), selectLabelVariants = cva(
  "font-semibold text-(--gray-primary-1) text-sm",
  {
    variants: {
      size: {
        sm: "py-0.5 px-1",
        default: "px-2 py-1.5",
        lg: "px-2 py-1.5"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), selectContentVariants = cva(
  cn`
    relative z-50 max-h-(--reka-select-content-available-height) min-w-[8rem] bg-(--white) border border-(--gray-tag-1)
    overflow-x-hidden overflow-y-auto rounded-md shadow-md
    data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95
    data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
    data-[side=top]:slide-in-from-bottom-2 data-[side=right]:slide-in-from-left-2 data-[side=bottom]:slide-in-from-top-2
    data-[side=left]:slide-in-from-right-2
  `,
  {
    variants: {
      position: {
        default: "",
        popper: "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1"
      }
    },
    defaultVariants: {
      position: "popper"
    }
  }
), selectContentViewportVariants = cva(null, {
  variants: {
    position: {
      default: "",
      popper: "h-(--reka-select-trigger-height) w-full min-w-(--reka-select-trigger-width) scroll-my-1"
    }
  },
  defaultVariants: {
    position: "popper"
  }
}), selectItemVariants = cva(
  cn`
    relative flex w-full items-center text-sm cursor-default outline-hidden select-none
    text-(--gray-text-2) data-[disabled]:pointer-events-none data-[disabled]:text-(--gray-border-3-alpha)
    focus:bg-(--gray-tag-1) data-[state=checked]:font-semibold data-[state=checked]:bg-(--tag-2-alpha)
    [&_svg]:pointer-events-none
  `,
  {
    variants: {
      size: {
        sm: "py-0.5 px-1 gap-1",
        default: "py-1.5 px-2 gap-2",
        lg: "py-1.5 px-2 gap-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
export {
  selectContentVariants,
  selectContentViewportVariants,
  selectItemVariants,
  selectLabelVariants,
  selectTextVariants,
  selectTriggerGroupVariants,
  selectTriggerSuffixVariants,
  selectTriggerVariants,
  selectValueTagVariants,
  selectValueVariants
};
//# sourceMappingURL=variants.js.map
